import React, { useState } from "react";
import { BsGithub } from "react-icons/bs";
import { FaGlobe, FaAppStoreIos, FaAndroid } from "react-icons/fa";
import { motion } from 'framer-motion';
import "./Project.css";
import Imagepopup from "./Imagepopup";

const ProjectsCard = ({ title, itemsDes, src, githubLink, webLink, androidLink, iosLink }) => {
  const [isPopupOpen, setPopupOpen] = useState(false);
  const imageUrls = src;

  const openPopup = () => setPopupOpen(true);
  const closePopup = () => setPopupOpen(false);

  return (
    <motion.div
      variants={{
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.4 } },
      }}
      className="w-full rounded-xl border border-white/10 bg-white/5 backdrop-blur-md group hover:border-cyan-500/30 hover:bg-cyan-500/5 transition-all duration-500 overflow-hidden"
    >
      <div className="w-full h-44 overflow-hidden relative">
        <img
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500 cursor-pointer"
          src={src[0]}
          onClick={openPopup}
          alt={title}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>

        <div className="absolute top-2 right-2 flex gap-1.5">
          {githubLink && (
            <a
              href={githubLink}
              target="_blank"
              rel="noopener noreferrer"
              className="w-7 h-7 rounded-full bg-black/60 backdrop-blur-md border border-white/10 inline-flex justify-center items-center text-gray-400 hover:text-cyan-400 hover:border-cyan-500/30 transition-all duration-300"
            >
              <BsGithub className="text-xs" />
            </a>
          )}
          {webLink && (
            <a
              href={webLink}
              target="_blank"
              rel="noopener noreferrer"
              className="w-7 h-7 rounded-full bg-black/60 backdrop-blur-md border border-white/10 inline-flex justify-center items-center text-gray-400 hover:text-cyan-400 hover:border-cyan-500/30 transition-all duration-300"
            >
              <FaGlobe className="text-xs" />
            </a>
          )}
          {androidLink && (
            <a
              href={androidLink}
              target="_blank"
              rel="noopener noreferrer"
              className="w-7 h-7 rounded-full bg-black/60 backdrop-blur-md border border-white/10 inline-flex justify-center items-center text-gray-400 hover:text-cyan-400 hover:border-cyan-500/30 transition-all duration-300"
            >
              <FaAndroid className="text-xs" />
            </a>
          )}
          {iosLink && (
            <a
              href={iosLink}
              target="_blank"
              rel="noopener noreferrer"
              className="w-7 h-7 rounded-full bg-black/60 backdrop-blur-md border border-white/10 inline-flex justify-center items-center text-gray-400 hover:text-cyan-400 hover:border-cyan-500/30 transition-all duration-300"
            >
              <FaAppStoreIos className="text-xs" />
            </a>
          )}
        </div>
      </div>

      <div className="p-4 flex flex-col gap-2">
        <h3 className="text-sm font-titleFont font-bold text-white group-hover:text-cyan-300 transition-colors duration-300">
          {title}
        </h3>
        {itemsDes && itemsDes.map((des, index) => (
          <p key={index} className="text-xs text-gray-400 leading-relaxed">
            {des}
          </p>
        ))}
      </div>

      {isPopupOpen && (
        <Imagepopup imageUrls={imageUrls} onClose={closePopup} />
      )}
    </motion.div>
  );
};

export default ProjectsCard;
